<template>
	<div v-html="content"></div>
</template>

<script>
	export default{
		name:'about',
		metaInfo() {
		  return {
			title: '付款方式 - ' + this.metaName,
			meta: [
			  { charset: "utf-8" },
			  { name: "keywords", content: this.metaKeywords },
			  { name: "description", content: this.metaDecs },
			],
		  };
		},
		data(){
			return{
				content:'',
				metaName: "",
				metaKeywords: "",
				metaDecs: "",
				tabPosition: 'left'
				
			}
		},
		mounted() {
			this.$axios({
				url:this.$utils.httpApi + 'index/webconfig'
			}).then(res=>{
				this.metaName = res.data.data.webtitle
				this.metaDecs = res.data.data.webdescription
				this.metaKeywords = res.data.data.webkeywords
			})
			this.$axios({
				url:this.$utils.httpApi + 'about/paytype'
			}).then(res=>{
				this.content = res.data.data
			})
		},
	}
</script>

<style>
</style>